import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import * as Sentry from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { AuthProvider } from '#globalContexts/AuthProvider';
import { ErrorProvider } from '#globalContexts/ErrorContext';
import { queryClient } from '#lib/queryClient';
import AppTrackingCodes from '#lib/trackingCodes';
import { createAppRoutes } from '#routes/AppRoutes';

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);
const router = sentryCreateBrowserRouter(createAppRoutes());

function App() {
	return (
		<>
			<AppTrackingCodes />
			<QueryClientProvider client={queryClient}>
				<ErrorProvider>
					<AuthProvider>
						<RouterProvider router={router} />
						<ReactQueryDevtools initialIsOpen={false} />
					</AuthProvider>
				</ErrorProvider>
			</QueryClientProvider>
		</>
	);
}

export default App;
